import { useMemo } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { resources } from "@constants/hardcoded-strings";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { ServiceOfferingRefreshRate } from "@idw-types/data/reference-data/generic";
import { FormattedRpServiceConfiguration, FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { ThemingSubTabContainer } from "../../../common/theming-sub-tab-container/theming-sub-tab-container";
import { FederatedIdpIdentityProvidersTabContainer } from "./federated-idp-identity-providers-tab-container/federated-idp-identity-providers-tab-container";
import { FederatedIdpReverificationTabContainer } from "./federated-idp-reverification-tab-container/federated-idp-reverification-tab-container";
import { FederatedIdpPropertiesTabContainer } from "./federated-idp-properties-tab-container/federated-idp-properties-tab-container";

type VerificationServiceDetailsFederatedIdpTabProps = {
    isDisabled: boolean;
    serviceOfferingRefreshRateDefault: string;
    serviceOfferingRefreshRates: Array<ServiceOfferingRefreshRate>;
    rpServiceConfigurationState: FormattedRpServiceConfiguration;
    setRpServiceConfigurationState: (state: FormattedRpServiceConfiguration) => void;
};

export const VerificationServiceDetailsFederatedIdpTab = (props: VerificationServiceDetailsFederatedIdpTabProps) => {
    const {
        isDisabled,
        serviceOfferingRefreshRateDefault,
        serviceOfferingRefreshRates,
        rpServiceConfigurationState,
        setRpServiceConfigurationState
    } = props;

    const updateServiceOffering = (serviceOffering: FormattedRpServiceConfigurationServiceOffering) => {
        const newServiceOfferings = rpServiceConfigurationState.serviceOfferings.map(so => so.uuid === serviceOffering.uuid
            ? serviceOffering
            : so
        );
        setRpServiceConfigurationState({
            ...rpServiceConfigurationState,
            serviceOfferings: newServiceOfferings
        });
    };

    const selectedServiceOfferings = useMemo(() => {
        return rpServiceConfigurationState.serviceOfferings.filter(so => so.addedToService && so.status === EntityStatusTypes.ACTIVE)
    }, [rpServiceConfigurationState.serviceOfferings]);

    return (
        <ThemingSubTabContainer>
            <Tabs id="federated-idp" unmountOnExit={true}>
                <Tab
                    eventKey={"federated-idp-identity-providers"}
                    title={resources.pages.verificationServiceDetails.tabs.federatedIdp.subTabs.identityProviders.tabName}
                >
                    <FederatedIdpIdentityProvidersTabContainer
                        isDisabled={isDisabled}
                        rpServiceConfigurationState={rpServiceConfigurationState}
                        setRpServiceConfigurationState={setRpServiceConfigurationState}
                    />
                </Tab>
                {selectedServiceOfferings.length > 0 && (
                    <Tab
                        eventKey={"federated-idp-reverification"}
                        title={resources.pages.verificationServiceDetails.tabs.federatedIdp.subTabs.reverification.tabName}
                    >
                        <FederatedIdpReverificationTabContainer
                            isDisabled={isDisabled}
                            serviceOfferingRefreshRateDefault={serviceOfferingRefreshRateDefault}
                            serviceOfferingRefreshRates={serviceOfferingRefreshRates}
                            serviceOfferings={selectedServiceOfferings}
                            updateServiceOffering={updateServiceOffering}
                        />
                    </Tab>
                )}
                {
                    rpServiceConfigurationState.permissions.canViewRPServiceProperties &&
                    (<Tab
                        eventKey={"federated-idp-properties"}
                        title={resources.pages.verificationServiceDetails.tabs.federatedIdp.subTabs.properties.tabName}
                    >
                        <FederatedIdpPropertiesTabContainer
                            isDisabled={isDisabled}
                            rpServiceConfigurationState={rpServiceConfigurationState}
                            setRpServiceConfigurationState={setRpServiceConfigurationState}
                        />

                    </Tab>)
                }

            </Tabs>
        </ThemingSubTabContainer>
    );
};